module.exports = __webpack_public_path__ + "img/1.641fbe14.jpg";